import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthService, Usuario} from '@sicapes/auth';
import {HttpClient} from "@angular/common/http";


@Component({
    selector: 'app-register',
    template: ''
})
export class RegisterComponent implements OnInit {

    error = '';

    constructor(private router: Router,
                private http: HttpClient,
                private route: ActivatedRoute,
                private authenticationService: AuthService) {

        // inicio:  Download de arquivos com autenticacao
        const isDownloadRoute = this.router.url.endsWith('/download');
        if (isDownloadRoute) {
            localStorage.setItem('urlFile', this.router.url);
            if (!this.authenticationService.getUsuario()) {
                this.router.navigate(['/login']);
            }
        }
        if (localStorage.getItem('urlFile') &&
            this.authenticationService.getUsuario()) {
            this.openUrlDownload();
        }
        // fim:  Download de arquivos com autenticacao


    }

    ngOnInit(): void {

        try {
            // recupera o accesstoken informado na url e armazena no service
            const querystring = this.route.snapshot.fragment;

            if (!querystring) {
                throw new Error('não foi possivel processar o login, dados de autenticação não informados');
            }

            // salva o access token
            const data: any = this.parseQuery(querystring);

            if (!data.access_token) {
                throw new Error('não foi possivel processar o login, dados de autenticação não encontrado');
            }

            this.authenticationService.register(data.access_token)
                .pipe()
                .subscribe(() => {
                        this.router.navigate(['/dashboard']);
                    },
                    error => {
                        this.error = error;
                    }
                );

        } catch (error) {

        }

    }

    /**
     * função para fazer o parse do valor no querystring
     */
    private parseQuery(qstr: any): any {
        const query = {};
        const a = (qstr[0] === '?' ? qstr.substr(1) : qstr).split('&');
        for (let i = 0; i < a.length; i++) {
            const b = a[i].split('=');
            query[decodeURIComponent(b[0])] = decodeURIComponent(b[1] || '');
        }
        return query;
    }

    openUrlDownload(): void {
        const url = localStorage.getItem('urlFile')?.replace('/auth', '/rest/inscricoes');
        localStorage.removeItem('urlFile');
        this.http.get(url, {
            responseType: 'blob',
            observe: 'response'
        }).subscribe({
            next: (response) => {
                const contentDisposition = response.headers.get('Content-Disposition');
                const fileName = decodeURIComponent(this.extractFilename(contentDisposition));
                const file = new File([response.body], fileName, {type: 'application/pdf'});
                const objectUrl = URL.createObjectURL(file);
                window.location.href = objectUrl;
                setTimeout(() => {
                    URL.revokeObjectURL(objectUrl);
                }, 10000);
            },
            error: err => {
                console.log(err);
            }
        });
    }

    extractFilename(contentDisposition: string | null): string | null {
        if (!contentDisposition) {
            return null;
        }
        const match = contentDisposition.match(/filename="([^"]+)"/i);
        if (!match) {
            return 'documento.pdf';
        }
        let filename = match[1];
        if (!filename.toLowerCase().endsWith('.pdf')) {
            filename += '.pdf';
        }
        return filename;
    }
}
